import { PageSection } from "@ui/common";
import { BitmaskExplanation, BitmaskInteractive } from "./BitmaskExample";

function AboutViewer() {
  return (
    <>
      <PageSection>
        <h4 className="text-3xl pt-9">The Mars Viewer</h4>
        <article>
          Mars Viewer is a portfolio project to demonstrate Deep Zoom-based
          visualisation, in particular, bit-masked tiled image visualisation. It
          has multiple layers of data visualization that, using different
          rendering techniques, show different aspects of our neighbouring
          planet.
        </article>
        <h4 className="text-3xl pt-9">About the Visualisation</h4>
        <article>
          This app uses a library called{" "}
          <a
            href="https://openseadragon.github.io/"
            target="_blank"
            rel="noopener noreferrer"
          >
            OpenSeadragon
          </a>{" "}
          to provide an interface for exploring Deep Zoom Images.
          <br /> Deep Zoom Images are a way to view massive images such as map
          data, and it works by creating tiles of the full resolution image at
          several zoom levels, which are then fetched when they're visible on
          the screen. Specifically, this app uses a library called{" "}
          <a
            href="https://www.npmjs.com/package/@lunit/osd-react-renderer"
            target="_blank"
            rel="noopener noreferrer"
          >
            OpenSeadragon-React-Renderer
          </a>
          , which is a React wrapper for OpenSeadragon that I maintained when
          working for Lunit. This publicly available library also provides
          several types of overlay that can be used to draw additional data on
          top of the base tile. This app utilises a tooltip overlay, a DeckGL
          overlay, and a prototype bit-masked tiled image overlay, to render the
          data.
        </article>
        <h4 className="text-3xl pt-9">Bit-Masked Rendering Technique</h4>
        <article>
          It's a technique that allows us to store multiple indexed layers of
          pixel-based data in a single image file. Typically, a PNG is an image
          file that has 4 colour channels - red, green, blue, and alpha. The
          colour of each pixel in the image is stored as four 8-bit numbers, for
          example - 230, 126, 15, 255 - which makes the colour of this app's
          logo text. An 8-bit number just means the computer gives us eight 0s
          or 1s that represent a number, such as 11100110.
        </article>
        <BitmaskExplanation />
        <article>
          Bit masking refers to a technique that lets us select individual
          values from a binary number. What if, instead of reading 11100110 as
          the number 230, we use it to mean 'this pixel belongs to any layer
          where the value is 1'? This technique is often used to store things
          like user's permissions in an application, but why not use it to
          control the colour of a pixel? By storing the data this way, a single
          pixel can belong to any and all layers, in any channel. Eight layers
          in four channels, means a pixel can belong to any combination of up to
          64 layers of data!
        </article>
        <BitmaskInteractive />
        <article className="pb-10">
          The workflow I created allows the user to toggle on or off any of
          these layers. If the pixel has a 1 in a given position, and its toggle
          is on, that layer's configured colour is added into the final colour
          you can see on the screen. This technique has a number of useful
          benefits. High density data layers is one, but another benefit is that
          by using a tiled image for this, you can use tiles with the same
          resolution as the base layer, and match its level of detail. This is
          particularly useful in the biomedical field, where scanner resolutions
          are always increasing.
        </article>
      </PageSection>
    </>
  );
}

export default AboutViewer;
